import React, { useContext } from 'react';
import './header.scss';
import { Helmet } from 'react-helmet-async';
import { KiaContext } from '../../../common/context/main.context';
import { getPageTitle } from '../../../common/utils/page.utils';
import Logo from '../../01_atoms/logo/Logo';

export default function HeaderSimple(props) {
  const { fixed } = props;
  const { meta, isB2c } = useContext(KiaContext);

  return (
    <header className={`header${ fixed ? ' header--fixed' : ''}`}>
      <Helmet>
        <title>{getPageTitle(isB2c)}</title>
        <meta property="og:url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <div className="header__content section">
        <div className="header__logo">
          <Logo fixed={fixed}/>
        </div>
      </div>
    </header>
  );
}
